import React, { useState } from "react";
import RoadToFM from "./blogs/RoadToFM";
import CharityBowl from "./blogs/CharityBowl";
import TheRAF from "./blogs/TheRAF";

export const ARTICLES = [
  {
    id: "road-to-fm",
    title: "The Road to Freemasonry",
    subtitle: "Introducing myself to the Lodge and the Lodge to Halton House.",
    Component: RoadToFM,
  },
  {
    id: "charity-bowl",
    title: "The Story Behind the Charity Bowl",
    subtitle: "Masonic charity in action at RAF 9456 Lodge.",
    Component: CharityBowl,
  },
  {
    id: "the-raf",
    title: "The Royal Air Force – my part in its downfall",
    subtitle: "With apologies to Spike Milligan.",
    Component: TheRAF,
  },
];

function Blog() {
  const [activeId, setActiveId] = useState(ARTICLES[0].id);
  const article = ARTICLES.find((a) => a.id === activeId) || ARTICLES[0];
  const ArticleBody = article.Component;

  return (
    <section className="section">
      <div className="container">
        <div style={{ maxWidth: "65ch" }}>
          <p className="eyebrow">From the Lodge</p>
          <h2>Stories &amp; reflections.</h2>
          <p className="lede">
            Reflections from the brethren — on the road to Freemasonry, the symbols we
            hold dear, and lives shaped by the Service.
          </p>
        </div>

        <div className="blog-layout">
          <nav aria-label="Articles">
            <ul className="blog-list">
              {ARTICLES.map((a) => (
                <li key={a.id}>
                  <button
                    aria-current={activeId === a.id ? "true" : "false"}
                    onClick={() => setActiveId(a.id)}
                  >
                    <span>{a.title}</span>
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <article className="blog-article fade-in" key={article.id}>
            <ArticleBody />
          </article>
        </div>
      </div>
    </section>
  );
}

export default Blog;
